// extracted by mini-css-extract-plugin
module.exports = {"product-image":"product-media-module__product-image___N0ofu","productImage":"product-media-module__product-image___N0ofu","slideshow":"product-media-module__slideshow___Q84ov"};